import { CSSObject } from '@chakra-ui/react';

export const BoxPageWrapper: CSSObject = {
  px: ['2.5', null, null, '3'],
};

export const BoxSectionWrapper: CSSObject = {
  mb: ['2', '4'],
};

export const BoxSportWrapper: CSSObject = {
  borderRadius: 'md',
  border: 'none',
};

export const TextTitle: CSSObject = {
  color: 'white',
  fontSize: 'sm',
};

export const LinkItem: CSSObject = {
  bgGradient: 'linear(to-b, gamma.400, gamma.500)',
  borderTopColor: 'alpha.600',

  svg: {
    color: 'alpha.600',
  },
  _hover: { bgGradient: 'linear(to-b, gamma.500, gamma.500)' },
};

export const IconSport: CSSObject = {
  color: 'alpha.600',
};

export const IconChevron: CSSObject = {
  boxSize: ['4', '5'],
  p: '1',
  color: 'alpha.600',
  transition: 'inherit',
};

export const TextName: CSSObject = {
  color: 'alpha.600',
  fontWeight: 'semibold',
};
